import React, {useEffect, useRef} from 'react';
import './WebsiteHostingCancellationRequest.css';

export default function WebsitePauseConfirmation({onCancel, onConfirm}) {
    const keepRef = useRef(null);
    useEffect(() => {
        const previous = document.activeElement;
        keepRef.current?.focus();
        return () => previous?.focus();
    }, []);
    return <div className="modal-overlay website-hosting-cancellation" onKeyDown={event => {
        if (event.key === 'Escape') { event.preventDefault(); onCancel(); }
        if (event.key === 'Tab') {
            const buttons = event.currentTarget.querySelectorAll('button');
            const first = buttons[0], last = buttons[buttons.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
    }}><div className="modal" role="dialog" aria-modal="true" aria-labelledby="website-pause-title" aria-describedby="website-pause-description">
        <h3 id="website-pause-title">Pause Website</h3>
        <p id="website-pause-description">Pause this website? Visitors will temporarily be unable to access it. Your subscription, saved content, and free dealership listing will remain unchanged.</p>
        <div className="modal-buttons">
            <button ref={keepRef} type="button" className="cancel-delete" onClick={onCancel}>Keep Published</button>
            <button type="button" className="confirm-delete" onClick={onConfirm}>Pause Website</button>
        </div>
    </div></div>;
}
